export const addHttp = (url) => {
  if (!url || url === "") return url;
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = "https://" + url;
  }
  return url;
};
